// extracted by mini-css-extract-plugin
export var productImage = "_qx-1";
export var viewLink = "_qx-2";
export var wishlistItem = "_qx-0";